import React, { useState, useEffect } from "react";
import Paragraph from "@arctheme-components/elements/Paragraph/Paragraph";
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import { Image } from "@arctheme-components/elements/Image/Image";

export const TelcoOurSolutions = ({ settings }) => {
  const {
    title,
    description
  }= settings.settings || [];
  const items = settings.settings.items || [];

  const isMobile = useMobileBreakpoint(settings.settings.mobile_breakpoint);
  const [isVisible, setIsVisible] = useState(false);
  const [activeSolution, setActiveSolution] = useState(0); // Track active solution index
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Track dropdown state
  
  useEffect(() => {
    // Add a small delay before showing the animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  // Get current active solution data
  const currentSolution = items[activeSolution] || items[0] || {};

  const handleSolutionClick = (index) => {
    setActiveSolution(index);
    if (isMobile) {
      setIsDropdownOpen(false); // Close dropdown after selection on mobile
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <section>
      <div className="flex flex-col gap-10">
        <div className="h5 capitalize">{description}</div>
        <div className={`flex ${isMobile ? 'flex-col' : 'gap-12'} w-full`}>
          {isMobile ? (
            // Mobile Custom Dropdown
            <div className="w-full mb-6 relative">
              <div className="flex flex-col justify-center">
                <div
                  className="flex items-center gap-2 w-full px-4 py-3 bg-white rounded-[5px] border border-[#F1E8DE] cursor-pointer"
                  onClick={toggleDropdown}
                >
                  <div className="flex-1">
                    {currentSolution.title || 'Select a solution'}
                  </div>
                  <div className="w-[1px] h-5 bg-[#3A4B24]"></div>
                  <div className="w-5 h-5 relative overflow-hidden text-[#3A4B24]">
                    <svg className="transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </div>
                </div>
                
                {/* Dropdown Options */}
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 w-full bg-white rounded-[5px] outline outline-1 outline-offset-[-1px] outline-color-brand-Alabaster shadow-lg z-10 mt-1">
                    {items.map((solution, index) => (
                      <div
                        key={index}
                        className={`px-4 py-3 cursor-pointer hover:bg-gray-50 border-b border-color-brand-Alabaster last:border-b-0 ${
                          activeSolution === index ? 'bg-gray-100' : ''
                        }`}
                        onClick={() => handleSolutionClick(index)}
                      >
                        <div className="text-Color-Brand-Pebble text-base font-normal font-['Poppins'] leading-6">
                          {solution.title}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ) : (
            // Desktop List
            <div className="inline-flex w-[420px]">
              <div className="flex flex-col gap-3 w-full">
                  {items.map((solution, index) => (
                    <div 
                      className="flex w-full cursor-pointer" 
                      key={index}
                      onClick={() => handleSolutionClick(index)}
                    >
                        <div className={`flex-1 px-5 py-3 rounded inline-flex flex-col gap-1 ${
                          activeSolution === index 
                            ? 'bg-[#1C1C1F] text-white' 
                            : 'hover:bg-[#1C1C1F] hover:text-white'
                        }`}>
                          <div className={`${isMobile ? 'b_medium_light' : 'b_medium_light'}`}>{solution.title}</div>
                          <div className={`font-normal font-["ubuntumono"] text-xs leading-4 tracking-[0.96px]`}>{solution.sub_title}</div>
                        </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
          <div className="flex flex-col gap-5 flex-1">
            <div className="flex flex-col gap-4">
              {currentSolution.image && (
                <Image
                  imageUrl={currentSolution.image}
                  alt={currentSolution.title}
                  isLazy={true}
                  classes="w-full object-cover rounded"
                />
              )}
              <div className={`flex ${currentSolution.layout_content == 'One Column' ? 'flex-col' : 'flex-col lg:flex-row'} gap-3`}>
                <div className="flex-1 inline-flex flex-col gap-3">
                  <div className={`${isMobile ? 'h4' : 'h5'}`}>{currentSolution.title}</div>
                  <div className={`font-normal font-["ubuntumono"] text-xs leading-4 tracking-[0.96px]`}>{currentSolution.sub_title}</div>
                </div>
                {currentSolution.content && (
                  <div className="flex-1">
                    <Paragraph
                      text={currentSolution.content}
                      classes={'rte b_small_normal'}
                      maxChars={0}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TelcoOurSolutions;